import { type JobSettingField } from '@/api/queries/jobsConfig';
import { Checkbox, Field, Input, Select } from '@/components/ui';

/**
 * Renders one typed job setting from a {@link JobSettingField} descriptor, mapping the
 * field's `type` to the matching control. Shared by the super-admin job settings form
 * (/admin/jobs/$key) and the tenant-admin job settings form (/settings/jobs).
 */
export function SettingField({
  field,
  value,
  onChange,
}: {
  field: JobSettingField;
  value: unknown;
  onChange: (value: unknown) => void;
}) {
  if (field.type === 'bool') {
    return (
      <Field hint={field.help ?? undefined}>
        <Checkbox checked={Boolean(value)} onChange={onChange} label={field.label} />
      </Field>
    );
  }

  if (field.type === 'enum') {
    return (
      <Field label={field.label} hint={field.help ?? undefined}>
        <Select
          value={String(value ?? '')}
          onChange={(e) => onChange(e.target.value)}
          options={(field.options ?? []).map((o) => ({ value: o, label: o }))}
        />
      </Field>
    );
  }

  if (field.type === 'number') {
    return (
      <Field label={field.label} hint={field.help ?? undefined}>
        <Input
          type="number"
          value={value == null ? '' : String(value)}
          onChange={(e) => onChange(e.target.value === '' ? null : Number(e.target.value))}
        />
      </Field>
    );
  }

  return (
    <Field label={field.label} hint={field.help ?? undefined}>
      <Input value={String(value ?? '')} onChange={(e) => onChange(e.target.value)} />
    </Field>
  );
}
